export default "__VITE_ASSET__2326ef1e__"